// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
    font-family: 'Inter', sans-serif;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    box-sizing: border-box;
    background-color: #ffffff; /* Ensure the navbar has a background color */
    box-shadow: none;
}

.navbar-logo img {
    height: 30px; /* Increased from 50px to 70px */
    width: auto; /* Maintain aspect ratio */
    transition: transform 0.3s ease; /* Optional: adds a smooth transition effect */
}

/* Optional: Add a hover effect to slightly enlarge the logo */
.navbar-logo img:hover {
    transform: scale(1.05);
}

.navbar-links {
    display: flex;
    align-items: center;
    gap: 20px;
}

.navbar-auth {
    display: flex;
    align-items: center;
    gap: 15px;
}

.nav-link {
    color: #333333;
    text-decoration: none;
    font-size: 1rem;
    transition: color 0.3s ease;
    font-weight: 500;
}

.nav-link:hover {
    color: #00C39A;
}

.nav-button {
    padding: 8px 16px;
    background-color: rgba(77, 182, 172, 0.7);
    color: #ffffff;
    border: none;
    border-radius: 9999px;
    cursor: pointer;
    font-size: 0.9rem;
    transition: background-color 0.3s ease, color 0.3s ease;
    font-weight: 500;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.nav-button:hover {
    background-color: #004d40;
}

.get-started {
    background-color: #004d40;
}

.get-started:hover {
    background-color: #4db6ac;
}

.account-button {
    background-color: #0047AB;
    text-decoration: none;
}

.account-button:hover {
    background-color: #003080;
}`, "",{"version":3,"sources":["webpack://./src/components/NavBar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,yBAAyB,EAAE,6CAA6C;IACxE,gBAAgB;AACpB;;AAEA;IACI,YAAY,EAAE,gCAAgC;IAC9C,WAAW,EAAE,0BAA0B;IACvC,+BAA+B,EAAE,8CAA8C;AACnF;;AAEA,8DAA8D;AAC9D;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,yCAAyC;IACzC,cAAc;IACd,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,uDAAuD;IACvD,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".navbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 20px;\n    font-family: 'Inter', sans-serif;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    box-sizing: border-box;\n    background-color: #ffffff; /* Ensure the navbar has a background color */\n    box-shadow: none;\n}\n\n.navbar-logo img {\n    height: 30px; /* Increased from 50px to 70px */\n    width: auto; /* Maintain aspect ratio */\n    transition: transform 0.3s ease; /* Optional: adds a smooth transition effect */\n}\n\n/* Optional: Add a hover effect to slightly enlarge the logo */\n.navbar-logo img:hover {\n    transform: scale(1.05);\n}\n\n.navbar-links {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.navbar-auth {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n}\n\n.nav-link {\n    color: #333333;\n    text-decoration: none;\n    font-size: 1rem;\n    transition: color 0.3s ease;\n    font-weight: 500;\n}\n\n.nav-link:hover {\n    color: #00C39A;\n}\n\n.nav-button {\n    padding: 8px 16px;\n    background-color: rgba(77, 182, 172, 0.7);\n    color: #ffffff;\n    border: none;\n    border-radius: 9999px;\n    cursor: pointer;\n    font-size: 0.9rem;\n    transition: background-color 0.3s ease, color 0.3s ease;\n    font-weight: 500;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n}\n\n.nav-button:hover {\n    background-color: #004d40;\n}\n\n.get-started {\n    background-color: #004d40;\n}\n\n.get-started:hover {\n    background-color: #4db6ac;\n}\n\n.account-button {\n    background-color: #0047AB;\n    text-decoration: none;\n}\n\n.account-button:hover {\n    background-color: #003080;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
